import commonEnHK from './common_en-HK'

const componentEnHK = {
  component: {
    ...commonEnHK,
  }
}

export default componentEnHK